export default "__VITE_ASSET__Y4s1EblS__"